/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/
import PropTypes from 'prop-types';

// Blocks interaction while the offline queue is actively replaying (uploads,
// item mutations, notes) after reconnecting — so a customer can't navigate
// or trigger another action mid-sync. Keyed off subscribeFlushing (genuinely
// in-progress replay), not the pending count, which can stay > 0 even after
// a pass has already given up on a real error and is just waiting for the
// next reconnect — that would otherwise leave this stuck open indefinitely.
const DataSyncOverlay = ({ isOpen }) => {
  if (!isOpen) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-0 z-[10000] bg-black/70 backdrop-blur-sm flex flex-col items-center justify-center px-6 text-center"
    >
      <div className="w-12 h-12 border-4 border-white/30 border-t-white rounded-full animate-spin mb-4" />
      <p className="text-white font-bold text-base">Syncing your data…</p>
      <p className="text-white/80 text-sm mt-1 max-w-xs">
        Please wait while we save your progress to the server. This won&apos;t take long.
      </p>
    </div>
  );
};

DataSyncOverlay.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

export default DataSyncOverlay;
